<template>
  <div :class="horizontal ? 'chart-container-horizontal' : 'chart-container'">
    <highcharts :options="chartOptions"></highcharts>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";

export default {
  name: "OrgToDByAttorney",
  components: {
    highcharts: Chart,
  },
  props: {
    attorneyData: {
      type: Array,
      required: true,
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    chartOptions() {
      const baseOptions = {
        chart: {
          type: this.horizontal ? "column" : "bar",
          height: this.horizontal ? 250 : 400,
        },
        title: {
          text: null,
        },
        xAxis: {
          categories: this.attorneyData.map((item) => item.attorney),
          title: {
            text: null,
          },
        },
        yAxis: {
          title: {
            text: "Time on Desk (days)",
          },
          min: 0,
        },
        series: [
          {
            name: "Time on Desk",
            data: this.attorneyData.map((item) => item.averageTod),
            color: "#4285f4",
          },
        ],
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
            },
          },
          column: {
            dataLabels: {
              enabled: true,
            },
          },
        },
      };
      return baseOptions;
    },
  },
};
</script>

<style scoped>
.chart-container {
  min-height: 400px;
  width: 100%;
}
.chart-container-horizontal {
  min-height: 250px;
  width: 100%;
}
</style>
